'use client'

import { memo } from 'react'
import { Apple, AppWindow } from 'lucide-react'
import { CRAFT_MEDIA } from './craft-media'

const TRUST_FACTS = [
  {
    icon: CRAFT_MEDIA.icons.offline,
    value: 'Offline',
    label: 'works without internet',
  },
  {
    icon: CRAFT_MEDIA.icons.drive,
    value: '~20 MB',
    label: 'lightweight installer',
  },
  {
    icon: CRAFT_MEDIA.icons.key,
    value: 'ZDR',
    label: 'cloud credits · zero retention',
  },
  {
    icon: CRAFT_MEDIA.icons.shield,
    value: 'SOC 2',
    label: 'audit in progress',
  },
] as const

/**
 * baby: Trust strip as craft paper board: cream cards + kraft icons (not flat SaaS tiles).
 */
export const CraftTrustStrip = memo(function CraftTrustStrip() {
  return (
    <div className="craft-trust" data-testid="craft-trust-strip">
      <div className="craft-trust__board">
        <span className="craft-trust__tape craft-trust__tape--tl" aria-hidden />
        <span className="craft-trust__tape craft-trust__tape--tr" aria-hidden />

        <div className="craft-trust__head">
          <div>
            <p className="craft-section__eyebrow">Built for real desktops</p>
            <p className="craft-trust__support">
              Private, fast, and ready the moment you install.
            </p>
          </div>
          <div className="craft-trust__platforms">
            <span className="craft-chip">
              <Apple className="craft-trust__platform-icon" aria-hidden />
              macOS
            </span>
            <span className="craft-chip">
              <AppWindow className="craft-trust__platform-icon" aria-hidden />
              Windows
            </span>
          </div>
        </div>

        <ul className="craft-trust__grid">
          {TRUST_FACTS.map((fact, index) => (
            <li
              key={fact.value}
              className={`craft-trust__fact craft-trust__fact--r${(index % 4) + 1}`}
            >
              <img
                src={fact.icon}
                alt=""
                aria-hidden
                className="craft-trust__icon"
                draggable={false}
              />
              <div className="craft-trust__value">{fact.value}</div>
              <div className="craft-trust__label">{fact.label}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
})

CraftTrustStrip.displayName = 'CraftTrustStrip'
